const parseResponse = async response =>
    await response.text().then(text => (text.length ? JSON.parse(text) : {}));

export default parseResponse;
